// FEWA

// import amber from "@mui/material/colors/amber";
import green from "@mui/material/colors/orange";
import { createTheme } from "@mui/material/styles";

export default createTheme({
  paper: {
    tertiary: {
      ///hausify hellgrau f2f2f2
      main: "#F1F1F1",
      text: "#000",
    },
  },
  palette: {
    primary: {
      ///hausify blau 00a2c7
      main: "#005492",
    },
    secondary: {
      ///hausify orange FCC332 (zb Head-Zeile Dropdown)
      // light
      // dark
      // FeSt Hausverwaltung #
      // FEWA 005492
      main: "#005492",
      contrastText: "#fff",
    },
    notification: {
      ticketBadge: {
        // The number configures the shade
        main: green[500],
        text: "#fff",
      },
    },
    importNotification: {
      main: "#4C5759",
      text: "#fff",
    },
    ticketsNotification: {
      ///hausify orange FCC332 (zb Meine Verwaltung)
      main: "#787378",
      text: "#fff",
    },
    estateNotification: {
      ///hausify rosa e3cfde
      main: "#e3cfde",
      contrastText: "#333",
    },
    postingsNotification: {
      ///hausify blau 00a2c7
      main: "#2E338C",
      text: "#fff",
    },

    documentsNotification: {
      main: "#eee",
      contrastText: "#333333",
      text: "#333333",
    },
    explainerBox: {
      main: "#777",
    },
  },
  typography: {
    fontFamily: ["roboto", "sans-serif", "serif"].join(","),
  },
});
